
import { Component, Prop } from '@modules/vue-property-decorator';
import { DateHelper } from '@shared/core/helpers/dateHelper';
import { Settings } from '@shared/core/services/configService';
import { CrudService } from '@shared/core/services/crudService';
import Vue from 'vue';
import VueSlickCarousel from "vue-slick-carousel";
import { Camp } from "./campPage.vue";
import { ShopService } from '@shared/core/services/shopService';
import { Format } from '@shared/core/helpers/formatHelper';
import { CustomerHelper } from '@shared/crm/helpers/customerHelper';

export interface Training {
  bookingId: number;
  description: string;
  start: string;
  startDateStr: string; // formatted
  startTimeStr: string;
  duration: number;
  canJoin: boolean;
}

@Component({
  components: {
    VueSlickCarousel,
  },
})
export default class CampTrainings extends Vue {
  @Prop({ required: true }) private camp!: Camp;
  private trainings: Training[] = [];
  private trainingError: {bookingId: number, errorMsg: string}|null = null;
  private get trainingsCarouselSettings() {
    return {
      dots: false,
      arrows: true,
      infinite: false,
      slidesToShow: 3,
      initialSlide: 0,
      variableWidth: false,
      rows: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          }
        },
        {
          breakpoint: 360,
          settings: {
            centerMode: true,
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ]
    }
  };

  async mounted() {
    await this.loadTrainings();
  }

  private async loadTrainings() {
    const url = `${Settings.HostName}/api/publiccamps/${this.camp.id}/trainings`;
    let data = await new CrudService().httpGet(url);
    if (data == null) {
      return;
    }

    const nextTrainings = data.model.next as Training[];
    this.trainings = nextTrainings.map(tr => {
      const startDate = DateHelper.toDate(tr.start, DateHelper.systemFormat)!;
      const startStr = DateHelper.toServerFormat(startDate);
      const now = new Date();
      return {
        ...tr,
        startDateStr: DateHelper.beautifyDate(startStr, true, false, true, false),
        startTimeStr: DateHelper.toCultureTimeString(startDate),
        canJoin: DateHelper.addDays(now, this.camp.anticipationDaysToOpenClassInscription)! >= startDate,
      };
    });
  }

  private async onTrainingInscriptionClick(training: Training, event: MouseEvent) {
    this.trainingError = null;
    if (!training.canJoin) return;
    const cid = CustomerHelper.getStoredCustomer();
    if (cid === undefined) {
      // this.showLoginRegister = true;
      return;
    }
    const url = `${Settings.HostName}/api/publicbookings/byplace-prebook-place/${cid}/${training.bookingId}/${Format.getOrigin()}`;

    const res = await new CrudService().httpPost(url, {});

    if (res == null || res == undefined) {
      console.error("Crash getting bookings by place");
      this.trainingError = { bookingId: training.bookingId, errorMsg: this.$t("Crash").toString() };
      return;
    }
    if (res.ok === false) {
      this.trainingError = { bookingId: training.bookingId, errorMsg: res.errorMsg };
      return;
    }

    if (res.model.serviceFree === true) {
      return this.$router.push("/customer-bookings");
    }

    let sale = res.model;
    sale.title = sale.description;
    sale.cancelUrl = `publicbookings/cancel/${training.bookingId}/${cid}`;

    new ShopService().addSaleToCart(sale, event.target as HTMLElement|null);
    this.$router.push("/checkout");
  }
}
